// landing-pages/src/config/fallback.ts
export const FALLBACK_PERSONAS = {
  high_technical: {
    key: "high_technical",
    name: "Strategic Technical Leader",
    landing_stages: [1, 4, 7, 10, 13, 14],
  },
  high_balanced: {
    key: "high_balanced",
    name: "Strategic Business Leader",
    landing_stages: [1, 3, 6, 9, 12, 14],
  },
  high_business: {
    key: "high_business",
    name: "Executive Decision Maker",
    landing_stages: [2, 3, 8, 13, 14],
  },
  medium_technical: {
    key: "medium_technical",
    name: "Technical Manager",
    landing_stages: [1, 3, 5, 6, 8, 11, 12, 14],
  },
  medium_balanced: {
    key: "medium_balanced",
    name: "Marketing Manager",
    landing_stages: [1, 2, 3, 4, 5, 8, 9, 14],
  },
  medium_business: {
    key: "medium_business",
    name: "Business Manager",
    landing_stages: [2, 3, 4, 7, 8, 9, 14],
  },
  low_technical: {
    key: "low_technical",
    name: "Technical Specialist",
    landing_stages: [3, 5, 6, 11, 12],
  },
  low_balanced: {
    key: "low_balanced",
    name: "Marketing Specialist",
    landing_stages: [1, 3, 5, 6, 8, 11],
  },
  low_business: {
    key: "low_business",
    name: "Business User",
    landing_stages: [2, 3, 8, 9, 14],
  },
};
